import React from "react";
import { getClassName } from "@sscs/utils";
import DotSeparator from "../DotSeparator/DotSeparator";
import styles from "./headerRow.module.scss";
const isVisible = (detail) => detail !== null &&
    detail !== undefined &&
    typeof detail !== "boolean" &&
    detail !== "";
const HeaderRow = ({ title, titleAs: TitleComponent, titleId, details, actions, classes, }) => {
    const visibleDetails = (details !== null && details !== void 0 ? details : []).filter(isVisible);
    return (React.createElement("div", { className: getClassName(styles.row, classes === null || classes === void 0 ? void 0 : classes.root) },
        React.createElement(TitleComponent, { id: titleId, className: getClassName(styles.title, classes === null || classes === void 0 ? void 0 : classes.title) }, title),
        visibleDetails.length > 0 ? (React.createElement(React.Fragment, null,
            React.createElement("span", { className: styles.pipe, "aria-hidden": "true" }),
            React.createElement("div", { className: getClassName(styles.details, classes === null || classes === void 0 ? void 0 : classes.details) }, visibleDetails.map((detail, index) => (React.createElement(React.Fragment, { key: index },
                index > 0 ? React.createElement(DotSeparator, null) : null,
                detail)))))) : null,
        actions !== undefined ? (React.createElement("div", { className: getClassName(styles.actions, classes === null || classes === void 0 ? void 0 : classes.actions) }, actions)) : null));
};
export default HeaderRow;
//# sourceMappingURL=HeaderRow.js.map